import { useNavigate } from "@tanstack/react-router";
import { useWebMCP } from "use-webmcp-tool";
import { runWebMCPTool } from "@/lib/webmcp-telemetry";

const SECTIONS: Record<string, string> = {
  predictions: "/predictions",
  "high-odds": "/high-odds",
  "safe-bets": "/safe-bets",
  "track-record": "/track-record",
  analysis: "/analysis",
  about: "/about",
  faq: "/faq",
};

/** Browser-local tools for agent browsers (WebMCP). Navigation only — no account actions. */
export function SiteAgentTools() {
  const navigate = useNavigate();

  useWebMCP({
    name: "open_statlign_section",
    description: "Open a public Statlign section: predictions, high-odds, safe-bets, track-record, analysis, about or faq.",
    inputSchema: {
      type: "object",
      properties: {
        section: { type: "string", enum: Object.keys(SECTIONS), description: "Section to open." },
      },
      required: ["section"],
    },
    execute: ({ section }: { section: string }) =>
      runWebMCPTool("open_statlign_section", async () => {
        const to = typeof section === "string" ? SECTIONS[section] : undefined;
        if (!to) throw new Error(`Unknown section; expected one of ${Object.keys(SECTIONS).join(", ")}.`);
        await navigate({ to });
        return `Opened ${section}.`;
      }),
  });

  useWebMCP({
    name: "read_current_page",
    description: "Read the main heading and summary of the Statlign page currently shown.",
    annotations: { readOnlyHint: true, untrustedContentHint: true },
    execute: () =>
      runWebMCPTool("read_current_page", () => {
        const h1 = document.querySelector("main h1, h1")?.textContent?.trim() ?? document.title;
        const desc = document.querySelector('meta[name="description"]')?.getAttribute("content") ?? "";
        return `${h1}\n${desc}\n${location.pathname}`;
      }),
  });

  return null;
}
